import { Injectable } from '@angular/core';
import swal from 'sweetalert2'
// declare var swal: any;

@Injectable()
export class SweetAlertService {

  constructor() {

  }

  showLoading(msg: string = "") {
    let html = `
            <div style="margin-top:30px;margin-bottom:50px;">
              <i class="fa fa-spinner fa-spin fa-4x fa-fw" style='color:#20a8d8'></i>
            </div>
    `
    if (msg.length > 0) {
        html += `<h3>${msg}</h3>`

    }
    swal({ html: html, showConfirmButton: false, allowOutsideClick: false, allowEscapeKey: false })

  }

  showSuccess(msg: string) {
    swal({ title: msg, type: 'success', timer: 1000, showConfirmButton: false, allowOutsideClick: false, allowEscapeKey: false })
    .then(function () {},
        // handling the promise rejection
        function (dismiss) {})
  }

  showError(msg:string,confirm:boolean = true) {
    swal({ title: msg, type: 'error',  showConfirmButton: confirm, allowOutsideClick: false, allowEscapeKey: false })
  }

  showConfirm(msg:string,func:Function) {
    swal({
      title: msg,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      confirmButtonText: '確定',
      cancelButtonText: '取消'
    }).then(
      () => func(),
      (dismiss) => {}
    )
  }

  dismiss() {
    swal.close()
  }

}



// WEBPACK FOOTER //
// ./src/app/services/sweetalert.service.ts